// extracted by mini-css-extract-plugin
module.exports = {"error_root":"GenericErrorMessage_error_root__1lRch","error_container_text":"GenericErrorMessage_error_container_text__3k6eg"};